<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-8 mb-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Search"
              aria-label="Search"
              aria-describedby="Search"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getJobTypes(1)">Search</button>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-1 text-right">
          <base-button
            type="primary"
            size="md"
            @click="modals.create_job_type_modal = true; newJobType.name = ''"
          >Create New</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="jobTypes"
      >
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Job Types Options</th>
          <th class="text-center">Actions</th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.name}}</span>
              </div>
            </div>
          </td>

          <td class="text-center">
            <base-dropdown class="dropdown" position="center">
              <a
                slot="title"
                class="btn btn-sm btn-icon-only text-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a
                  class="dropdown-item"
                  @click="modals.update_modal = true; jobTypeId = row.job_type_id; updateJobTypeById.name = row.name"
                >Update</a>
                <a
                  class="dropdown-item"
                  @click="modals.confirmation_modal = true; jobTypeId = row.job_type_id"
                >Delete</a>
              </template>
            </base-dropdown>
          </td>
        </template>
      </base-table>
    </div>

    <div class="row" id="div-create-job-type-modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.create_job_type_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">CREATE NAME: JOB TYPE</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      <span>Name:</span>
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <base-input
                        alternative
                        placeholder="Name"
                        input-classes="form-control-alternative"
                        type="text"
                        v-model="newJobType.name"
                      />
                    </div>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.create_job_type_modal = false"
                    >Cancel</base-button>
                    <base-button type="success" class="my-4" @click="createJobType()">Create</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div class="row" id="div-update-job-type-modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.update_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">UPDATE NAME: JOB TYPE</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      <span>Name:</span>
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <base-input
                        alternative
                        placeholder="Name"
                        input-classes="form-control-alternative"
                        type="text"
                        v-model="updateJobTypeById.name"
                      />
                    </div>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.update_modal = false"
                    >Cancel</base-button>
                    <base-button
                      type="success"
                      class="my-4"
                      @click="updateJobType(jobTypeId)"
                    >Update</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div class="row" id="div-confirmation-modal">
      <modal :show.sync="modals.confirmation_modal">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">Delete</h5>
        </template>
        <div>Are you sure?</div>
        <template slot="footer">
          <base-button type="secondary" @click="modals.confirmation_modal = false">Close</base-button>
          <base-button type="primary" @click="deleteJobType(jobTypeId)">Yes</base-button>
        </template>
      </modal>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination :perPage="10" :total="totalJobType" :value="pageNumber"></base-pagination>
    </div>
  </div>
</template>
<script>
import EventBus from "./../../event-bus";

export default {
  name: "job-types-table",
  props: {
    type: {
      type: String
    },
    title: String
  },
  data() {
    return {
      search_text: "",
      totalJobType: 0,
      show: false,
      message: "",
      jobTypeId: 0,
      newJobType: {
        name: ""
      },
      updateJobTypeById: {
        name: ""
      },
      modals: {
        create_job_type_modal: false,
        confirmation_modal: false,
        update_modal: false
      }
    };
  },
  computed: {
    jobTypes() {
      return this.$store.getters.jobTypes;
    },
    pageNumber() {
      return parseInt(this.$route.query.page);
    },
    totalJobTypes() {
      return this.totalJobType;
    }
  },
  watch: {
    pageNumber() {
      this.getJobTypes(this.$route.query.page);
    }
  },
  mounted() {
    this.getJobTypes(1);
    this.getTotalJobTypes();
  },
  methods: {
    getJobTypes: function(page_number) {
      this.$store.dispatch("fetchJobTypes", { keyword: this.search_text, page: page_number }).then(response => {
        const { data, meta } = response.data;
        this.totalJobType = meta.total_result;
        this.$router.push({ query: { page: page_number } });
        this.$store.dispatch("updateState", {
          key: "jobTypes",
          value: data
        });
      });
    },

    getTotalJobTypes() {
      this.$store.dispatch("fetchTotalJobType").then(response => {
        this.totalJobType = parseInt(response.data);
      });
    },

    createJobType() {
      this.$store
        .dispatch("createJobType", {
          name: this.newJobType.name
        })
        .then(response => {
          if (response.data.error == "1000") {
            var page = this.$route.query.page;
            if ((this.totalJobTypes % 10) === 0) {
              page++;
            }
            this.modals.create_job_type_modal = false;
            this.getJobTypes(page);
            EventBus.$emit("updateJobTypeCount");
          } else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    updateJobType: function(job_type_id) {
      this.$store
        .dispatch("updateJobType", {
          id: job_type_id,
          name: this.updateJobTypeById.name
        })
        .then(response => {
          this.modals.update_modal = false;
          this.getJobTypes(this.$route.query.page);
          this.getTotalJobTypes();
          EventBus.$emit("updateJobTypeCount");
        });
    },

    deleteJobType: function(job_type_id) {
      this.$store
        .dispatch("deleteJobType", {
          id: job_type_id
        })
        .then(response => {
          var page = this.$route.query.page;
          if ((this.totalJobTypes % 10) === 1) {
            page--;
          }
          this.modals.confirmation_modal = false;
          this.getJobTypes(page);
          EventBus.$emit("updateJobTypeCount");
        });
    }
  }
};
</script>
<style>
</style>
